'use strict';

module.exports = function () {
    // Custom Start: Make cart product images responsive //
    const target = document.querySelector('.minicart');

    if (target) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (target.innerHTML.length > 0) {
                    if (typeof window.makeCloudinaryImagesResponsive !== 'undefined') {
                        window.makeCloudinaryImagesResponsive();
                    }
                }
            }
        });

        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }
    // Custom End: Make cart product images responsive //
};
